import { MutableRefObject } from 'react';
import { RIGHT_ARROW, LEFT_ARROW, ENTER_KEY, SPACE_KEY, KeyCode } from 'constants/keyCodes';

export const useContentEditorSelectorKeyPress = () => {
  const handleKeyPress = (
    { keyCode }: { keyCode: KeyCode },
    refs: MutableRefObject<HTMLDivElement | null>[],
  ) => {
    try {
      const focusedIndex = refs.findIndex((opt) => opt.current === document.activeElement);
      const isItemFocused = focusedIndex > -1;
      const focusedItem = refs[focusedIndex].current;

      switch (keyCode) {
        case RIGHT_ARROW: {
          if (isItemFocused && focusedIndex < refs.length - 1) {
            refs[focusedIndex + 1]?.current?.focus();
          }
          break;
        }

        case LEFT_ARROW: {
          if (isItemFocused && focusedIndex > 0) {
            refs[focusedIndex - 1]?.current?.focus();
          }
          break;
        }

        case SPACE_KEY:
        case ENTER_KEY: {
          focusedItem?.click();
          break;
        }

        default:
          break;
      }
    } catch (err) {
      console.error(err); // eslint-disable-line
    }
  };
  return handleKeyPress;
};
